import { z } from "zod";
import { Entity } from "../../common/entity";
import { DocumentationPageContentData } from "../../dsm";
import { PageBlockDefinition } from "../../dsm/documentation/block-definitions/definition";
import { PageSectionEditorModelV2 } from "../../dsm/elements/data/documentation-section-v2";
import { DocumentationItemConfigurationV2 } from "../../dsm/elements/data/documentation-v2";
import { DocumentationPageV2 } from "../../dsm/elements/documentation-page-v2";
import { ElementGroup } from "../../dsm/elements/group";
import { PageBlockEditorModelV2 } from "../../dsm/elements/page-block-v2";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";

export const DocumentationPageRoom = Entity.extend({
  designSystemVersionId: z.string(),
  documentationPageId: z.string(),
  liveblocksId: z.string(),
  isDirty: z.boolean(),
});

export type DocumentationPageRoom = z.infer<typeof DocumentationPageRoom>;

export type CreateDocumentationPageRoom = DbCreateInputOmit<DocumentationPageRoom>;
export type UpdateDocumentationPageRoom = OmitStrict<
  DbUpdate<DocumentationPageRoom>,
  "designSystemVersionId" | "documentationPageId" | "liveblocksId"
>;

//
// Room content
//

export const DocumentationPageRoomState = z.object({
  pageItems: z.array(PageBlockEditorModelV2.or(PageSectionEditorModelV2)),
});

export const DocumentationPageRoomRoomUpdate = z.object({
  page: DocumentationPageV2,
  pageParent: ElementGroup,
});

export const DocumentationPageRoomInitialStateUpdate = DocumentationPageRoomRoomUpdate.extend({
  pageItems: z.array(PageBlockEditorModelV2.or(PageSectionEditorModelV2)),
  blockDefinitions: z.array(PageBlockDefinition),
});

export const RestoredDocumentationPage = z.object({
  page: DocumentationPageV2,
  pageParent: ElementGroup,
  pageContent: DocumentationPageContentData,
  contentHash: z.string(),
});

export const RestoredDocumentationGroup = z.object({
  group: ElementGroup,
  parent: ElementGroup,
});

export type DocumentationPageRoomState = z.infer<typeof DocumentationPageRoomState>;
export type DocumentationPageRoomRoomUpdate = z.infer<typeof DocumentationPageRoomRoomUpdate>;
export type DocumentationPageRoomInitialStateUpdate = z.infer<typeof DocumentationPageRoomInitialStateUpdate>;
export type RestoredDocumentationPage = z.infer<typeof RestoredDocumentationPage>;
export type RestoredDocumentationGroup = z.infer<typeof RestoredDocumentationGroup>;
